'use client';

import { useReportError } from '@/hooks/useReportError';

/**
 * Root error boundary. Catches errors thrown while rendering the root layout /
 * template — the one place segment `error.tsx` boundaries cannot reach. It fully
 * replaces the root layout when active, so it must render its own <html>/<body>
 * and cannot rely on providers, fonts, or i18n (any of which may be the failure).
 */
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useReportError(error);

  return (
    <html lang="en">
      <body
        style={{
          minHeight: '100dvh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 16,
          padding: 24,
          fontFamily: 'system-ui, sans-serif',
          textAlign: 'center',
        }}
      >
        <h1 style={{ fontSize: 20, fontWeight: 600 }}>Something went wrong</h1>
        <p style={{ color: '#525252' }}>An unexpected error occurred. Please try again.</p>
        <button
          type="button"
          onClick={() => reset()}
          style={{
            padding: '10px 20px',
            borderRadius: 8,
            border: 0,
            background: '#FA5002',
            color: 'white',
            fontSize: 14,
            fontWeight: 600,
            cursor: 'pointer',
          }}
        >
          Try again
        </button>
      </body>
    </html>
  );
}
